/**
 * Retourne la page d'accueil naturelle selon le rôle de l'utilisateur.
 */

const ADMIN_SLUGS = ['super-admin', 'admin-organisation', 'admin-national', 'admin-diocesain'];
const PAIE_SLUGS = [...ADMIN_SLUGS, 'gestionnaire-paie', 'comptable'];

export function getAccueilParRole(role?: string): string {
  if (!role) return '/dashboard';
  if (ADMIN_SLUGS.includes(role)) return '/admin';
  if (PAIE_SLUGS.includes(role)) return '/paie/bulletins';
  if (role === 'employe') return '/espace-salarie';
  return '/dashboard';
}

export { ADMIN_SLUGS, PAIE_SLUGS };
